import Backbone from 'backbone';
import SaveShoppingListModel from 'models/store/client/projects/save_shopping_list';

export const ShoppingListSelectorProjectView = Backbone.View.extend({
	events: {
		'click .js-collapse-toggle': 'toggleProjectCollapse',
		'click .js-shopping-list-group': 'handleGroupClick',
		'click .js-project': 'handleProjectClick',
		'click .js-new-group': 'handleNewShoppingListClick',
		'keyup .js-new-group-input': 'handleNewGroupKeypress',
		'click .js-submit-new-group': 'saveGroup'
	},

	initialize: function(options = {}) {
		const groups = this.model.get('shoppingLists') || [];
		this.parentView = options.parentView;
		this.namelessGroup = groups.find((group) => group.name === null);
		this.projectId = this.model.get('project').id;
		this.cacheSelectors();
	},
	cacheSelectors: function() {
		this.$collapseIcon = this.$el.find('.js-collapse');
		this.$expandIcon = this.$el.find('.js-expand');
		this.$collapseContent = this.$el.find('.js-shopping-lists-container');
		this.$newGroup = this.$el.find('.js-new-group');
		this.$newGroupInput = this.$el.find('.js-new-group-input');
	},
	handleNewShoppingListClick: function() {
		if (this.$newGroup.hasClass('editing')) {
			return;
		}
		this.$newGroup.addClass('editing');
		this.$newGroup.children().toggleClass('dn');
		this.$newGroupInput.focus();
	},
	toggleProjectCollapse: function() {
		if (this.$collapseContent.hasClass('collapsing')) {
			return;
		}
		this.$collapseIcon.toggleClass('dn');
		this.$expandIcon.toggleClass('dn');
		this.$collapseContent.collapse('toggle');
	},
	handleNewGroupKeypress: function(e) {
		if (e.key === 'Enter') {
			this.saveGroup();
		}
		if (e.key === 'Escape' || e.key === 'Esc') {
			this.cancelNewGroupInput(e);
		}
	},
	cancelNewGroupInput: function() {
		this.$newGroup
			.removeClass('editing')
			.children()
			.toggleClass('dn');
	},
	saveGroup: function() {
		const name = this.$newGroupInput.val();
		if (!this.isNewGroupValid(name)) {
			return false;
		}
		const model = new SaveShoppingListModel({
			name,
			projectId: this.projectId
		});
		model.save().then(() => {
			this.parentView.respond(this.getResponseData(model.toJSON()));
		});
	},
	isNewGroupValid: function(newGroupName) {
		const otherGroupNames = this.getAllGroupNames();
		if (!newGroupName || newGroupName.length < 4) {
			window.BCOM.notifications.render('Please enter a group name longer than three characters.', 'danger');
			return false;
		}
		if (otherGroupNames.includes(newGroupName)) {
			window.BCOM.notifications.render('You already have a group with this name in this project.', 'danger');
			return false;
		}
		return true;
	},
	getAllGroupNames: function() {
		const lists = this.model.get('shoppingLists') || [];
		return lists.map((list) => list.name);
	},
	handleGroupClick: function(e) {
		const $target = $(e.currentTarget),
			groupId = $target.data('groupId'),
			group = this.model.get('shoppingLists').find((group) => group.projectShoppingListGroupId === groupId);
		this.parentView.respond(this.getResponseData(group));
	},
	handleProjectClick: function() {
		if (this.namelessGroup) {
			this.parentView.respond(this.getResponseData(this.namelessGroup));
		} else {
			this.parentView.createNamelessGroup(this.getResponseData());
		}
	},
	getResponseData(group = {}) {
		return {
			id: this.projectId,
			name: this.model.get('project').name,
			selectedGroup: {
				name: group.name,
				sessionCartId: group.sessionCartId || group.cartId || (group.sessionCart ? group.sessionCart.sessionCartId : null)
			}
		};
	}
});
